import m from 'mithril'

export default {
    view({ attrs }) {
        return m("div.col-lg-12.col-xl-12",
            m("div.k-portlet.k-portlet--height-fluid",
                [
                    m("div.k-portlet__head.k-portlet__head--noborder",
                        [
                            m("div.k-portlet__head-label",
                                m("h3.k-portlet__head-title",
                                    attrs.title
                                )
                            )
                        ]
                    ),
                    m("div.k-portlet__body.k-portlet__body--fluid",
                        m("div.k-widget-19", {
                            style: {
                                "padding-bottom": "20px",
                                "padding-left": "20px"
                            }
                        },
                            [
                                m("div.k-widget-19__title",
                                    [
                                        m("div.k-widget-19__label",
                                            [
                                                // m("small",
                                                //     "$"
                                                // ),
                                                attrs.value
                                            ]
                                        ),
                                        m("img.k-widget-19__bg[src='./assets/media/misc/iconbox_bg.png'][alt='bg']")
                                    ]
                                )
                            ]
                        )
                    )
                ]
            )
        )
    }
}